import { apiClient } from './client'

export interface AdminUser {
  id: number
  name: string
  email: string
  role: string
  is_active: number
  email_verified_at: string | null
  created_at: string | null
  updated_at: string | null
  ai_modes?: string[]
}

export interface AdminUsersResponse {
  users: AdminUser[]
}

export async function getAdminUsers(): Promise<AdminUsersResponse> {
  const response = await apiClient.get('/api/admin/users')
  return response.data as AdminUsersResponse
}

export interface UpdateAdminUserPayload {
  role?: string
  is_active?: number
  ai_modes?: string[]
}

export async function updateAdminUser(
  userId: number,
  payload: UpdateAdminUserPayload,
): Promise<void> {
  await apiClient.put(`/api/admin/users/${userId}`, payload)
}

export async function deleteAdminUser(userId: number): Promise<void> {
  await apiClient.delete(`/api/admin/users/${userId}`)
}

export interface ProjectAccess {
  id: number
  user_id: number
  project_id: number
  role_in_project: string
  project_name: string
  created_at: string
  updated_at: string
}

export interface ProjectAccessResponse {
  access: ProjectAccess[]
}

export async function getProjectAccess(userId: number): Promise<ProjectAccessResponse> {
  const response = await apiClient.get('/api/admin/project-access', {
    params: { user_id: userId },
  })
  return response.data as ProjectAccessResponse
}

export async function upsertProjectAccess(
  userId: number,
  projectId: number,
  roleInProject: string,
): Promise<void> {
  await apiClient.post('/api/admin/project-access', {
    user_id: userId,
    project_id: projectId,
    role_in_project: roleInProject,
  })
}

export async function deleteProjectAccessById(id: number): Promise<void> {
  await apiClient.delete('/api/admin/project-access', {
    data: { id },
  } as any)
}

export interface PermissionRow {
  id: number
  user_id: number
  project_id: number
  resource_type: string
  resource_id: string | null
  permission: string
  created_at: string
  updated_at: string
}

export interface PermissionsResponse {
  permissions: PermissionRow[]
}

export async function getUserPermissions(
  userId: number,
  projectId: number,
): Promise<PermissionsResponse> {
  const response = await apiClient.get('/api/admin/permissions', {
    params: { user_id: userId, project_id: projectId },
  })
  return response.data as PermissionsResponse
}

export interface CreatePermissionPayload {
  user_id: number
  project_id: number
  resource_type: string
  resource_id?: string | null
  permission: string
}

export async function createPermission(payload: CreatePermissionPayload): Promise<number> {
  const response = await apiClient.post('/api/admin/permissions', payload)
  const data = response.data as { id: number }
  return data.id
}

export async function deletePermissionById(id: number): Promise<void> {
  await apiClient.delete('/api/admin/permissions', {
    data: { id },
  } as any)
}



